"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ellipsisText = exports.fontFamilies = void 0;

var tslib_1 = require("tslib");

var styled_components_1 = require("styled-components");

exports.fontFamilies = {
  highlight: '"DB Heavent Now", sans-serif'
};

exports.ellipsisText = function (line) {
  return styled_components_1.css(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n\tword-break: break-word;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n\t", ";\n"], ["\n\tword-break: break-word;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n\t", ";\n"])), line > 1 ? styled_components_1.css(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t-webkit-line-clamp: ", ";\n\t\t\t\t-webkit-box-orient: vertical;\n\t\t  "], ["\n\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t-webkit-line-clamp: ", ";\n\t\t\t\t-webkit-box-orient: vertical;\n\t\t  "])), line) : styled_components_1.css(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n\t\t\t\twhite-space: nowrap;\n\t\t  "], ["\n\t\t\t\twhite-space: nowrap;\n\t\t  "]))));
};

var templateObject_1, templateObject_2, templateObject_3;